import { onboardingModalActionTypes } from './Constants';

const initialState = {
	open: false,
	loading: true,
	data: [],
	parentModalOnClose: null,
};

export default function onboardingModalReducer(state = initialState, action) {
	const { type, payload } = action;
	const { data, parentModalOnClose } = payload || {};

	switch (type) {
		case onboardingModalActionTypes.CLOSE_ONBOARDING_MODAL:
			return {
				...state,
				open: false,
			};
		case onboardingModalActionTypes.GET_ONBOARDING_MODAL_REQUEST:
			return {
				...state,
				open: data.identifier !== 'b2s_23' && data.identifier !== 'exercise_completed',
				loading: true,
				parentModalOnClose,
			};
		case onboardingModalActionTypes.GET_ONBOARDING_MODAL_SUCCESS:
			return {
				...state,
				...data,
				loading: false,
			};
		case onboardingModalActionTypes.GET_ONBOARDING_MODAL_ERROR:
			return {
				...state,
				loading: false,
				open: false,
			};
		case onboardingModalActionTypes.CLEAR_ONBOARDING_MODAL:
			return initialState;
		default:
			return state;
	}
}
